// ─────────────────────────────────────────────────────────────────────────────
// Crew — small presentational formatters (Agent B). Pure, no I/O.
// ─────────────────────────────────────────────────────────────────────────────

/**
 * priceFromPence is an INTEGER number of pence. 0 (or undefined) renders "Free";
 * otherwise "£x.xx". Never divide in template strings elsewhere — use this.
 */
export function formatPrice(pence?: number): string {
  if (pence == null || pence <= 0) return 'Free';
  return `£${(pence / 100).toFixed(2)}`;
}

/** Format an ISO datetime for a slot label, e.g. "Sat 21 Jun, 19:00". */
export function formatSlot(startISO: string, endISO?: string): string {
  const start = new Date(startISO);
  if (Number.isNaN(start.getTime())) return startISO;
  const date = start.toLocaleDateString('en-GB', {
    weekday: 'short',
    day: 'numeric',
    month: 'short',
  });
  const time = start.toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' });
  if (endISO) {
    const end = new Date(endISO);
    if (!Number.isNaN(end.getTime())) {
      const endTime = end.toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' });
      return `${date}, ${time}–${endTime}`;
    }
  }
  return `${date}, ${time}`;
}

/** Human label for a date input value (YYYY-MM-DD) → ISO at midday local. */
export function dateInputToISO(value: string): string | undefined {
  if (!value) return undefined;
  const d = new Date(`${value}T12:00:00`);
  return Number.isNaN(d.getTime()) ? undefined : d.toISOString();
}

/** Turn an unknown thrown value into a user-safe message. */
export function errorMessage(err: unknown, fallback = 'Something went wrong. Please try again.'): string {
  if (err instanceof Error && err.message) return err.message;
  if (typeof err === 'string' && err) return err;
  return fallback;
}
